import { ProductReviewLandingView } from './ProductReviewLandingView';
import { PRECONTENT, CONTENT } from './mockedContent';

// eslint-disable-next-line react/prop-types
const ProductReviewLanding = ({ shingleLine }) => (
  <ProductReviewLandingView precontent={PRECONTENT} content={CONTENT} shingleLine={shingleLine} />
);

export { ProductReviewLanding };
